function t(value){
  switch(value){
    case 'Aucun bagage':      return 'No luggage';   break;
    case '1 bagage':      return '1 piece of luggage';   break;
    case '5 bagages et +':      return '5 pieces of luggage and more';   break;
    case '5 et +':      return '5 and more';   break;
    case '%count bagages':      return '%count pieces of luggage';   break;
    case 'Avec skis':      return 'With skis';   break;
    case 'Sans skis':      return 'Without skis';   break;
    case 'Annuler':      return 'Cancel';   break;
    case 'Effacer':      return 'Erase';   break;
    case 'OK':      return 'OK';   break;
    case 'Janvier':      return 'January';   break;
    case 'Février':      return 'February';   break;
    case 'Mars':      return 'March';   break;
    case 'Avril':      return 'April';   break;
    case 'Mai':      return 'May';   break;
    case 'Juin':      return 'June';   break;
    case 'Juillet':      return 'July';   break;
    case 'Août':      return 'August';   break;
    case 'Septembre':      return 'September';   break;
    case 'Octobre':      return 'October';   break;
    case 'Novembre':      return 'November';   break;
    case 'Décembre':      return 'December';   break;
    case 'Jan.':      return 'Jan.';   break;
    case 'Fév.':      return 'Feb.';   break;
    case 'Mars':      return 'Mar.';   break;
    case 'Avril':      return 'Apr.';   break;
    case 'Mai':      return 'May';   break;
    case 'Juin':      return 'June';   break;
    case 'Juil.':      return 'July';   break;
    case 'Août':      return 'Aug.';   break;
    case 'Sept.':      return 'Sept.';   break;
    case 'Oct.':      return 'Oct.';   break;
    case 'Nov.':      return 'Nov.';   break;
    case 'Déc.':      return 'Dec.';   break;
    case 'Dimanche':      return 'Sunday';   break;
    case 'Lundi':      return 'Monday';   break;
    case 'Mardi':      return 'Tuesday';   break;
    case 'Mercredi':      return 'Wednesday';   break;
    case 'Jeudi':      return 'Thursday';   break;
    case 'Vendredi':      return 'Friday';   break;
    case 'Samedi':      return 'Saturday';   break;
    case 'Dim':      return 'Sun';   break;
    case 'Lun':      return 'Mon';   break;
    case 'Mar':      return 'Tue';   break;
    case 'Mer':      return 'Wed';   break;
    case 'Jeu':      return 'Thu';   break;
    case 'Ven':      return 'Fri';   break;
    case 'Sam':      return 'Sat';   break;
    case 'D':      return 'S';   break;
    case 'L':      return 'M';   break;
    case 'M':      return 'T';   break;
    case 'M':      return 'W';   break;
    case 'J':      return 'T';   break;
    case 'V':      return 'F';   break;
    case 'S':      return 'S';   break;
    case 'Avion':      return 'Plane';   break;
    case 'Train':      return 'Train';   break;
    case 'Autre':      return 'Other';   break;
    case 'Dans quelle ville ?':      return 'In which town?';   break;
    case 'Numéro de vol':      return 'Flight number';   break;
    case 'Numéro de train':      return 'Train number';   break;
    case 'Ignorer':      return 'Ignore';   break;
    case 'Suivant':      return 'Next';   break;
    case 'Adresse':      return 'Address';   break;
    case 'Rue':      return 'Street';   break;
    case "Complément d'adresse":      return 'Additional address';   break;
    case 'Code postal':      return 'Zip code';   break;
    case 'Ville':      return 'Town/City';   break;
    case 'Dans quelle station ?':      return 'In which ski resort?';   break;
    case 'Dans quel secteur ?':      return 'In which area?';   break;
    case 'Où séjournerez-vous ?':      return 'Where will you stay?';   break;
    case 'Hôtel/Résidence':      return 'Hotel/Residence';   break;
    case 'Une arrivée':      return 'An arrival';   break;
    case 'Un départ':      return 'A departure';   break;
    case 'Oui':      return 'Yes';   break;
    case 'Non':      return 'No';   break;
    case 'Votre demande de transfert concerne ...':      return 'Your transfer request concerns ...';   break;
    case 'Vous pourrez ajouter un retour une fois votre arrivée renseignée.':      return 'You can add a way back once your arrival is filled.';   break;
    case 'Combien de passagers ?':      return 'How many passengers?';   break;
    case 'Plus de 7 passagers ?  Envoyez-nous votre demande <a href="/fr/contact">ici</a>.':      return 'More than 7 passengers ? Send us your request <a href="/en/contact">here</a>.';   break;
    case 'Plus de 8 passagers ?  Envoyez-nous votre demande <a href="/fr/contact">ici</a>.':      return 'More than 8 passengers ? Send us your request <a href="/en/contact">here</a>.';   break;
    case 'Combien de bagages ?':      return 'How much luggage?';   break;
    case 'Aurez-vous des skis à transporter ?':      return 'Will you have skis to transport?';   break;
    case 'Combien de paires de skis ?':      return 'How much pairs of skis?';   break;
    case 'A quelle date souhaitez-vous partir ?':      return 'When do you want to leave?';   break;
    case 'A quelle date arrivez-vous ?':      return 'When do you arrive?';   break;
    case 'Date':      return 'Date';   break;
    case 'Heure':      return 'Hour';   break;
    case 'Min':      return 'Min';   break;
    case 'Lieu de prise en charge':      return 'Pick-up location';   break;
    case 'Lieu de dépose':      return 'Destination';   break;
    case 'Tarif :':      return 'Rate:';   break;
    case 'Durée :':      return 'Duration:';   break;
    case 'Non défini':      return 'Undefined';   break;
    case 'Départ :':      return 'Pick-up:';   break;
    case 'Arrivée :':      return 'Drop-off:';   break;
    case 'Aéroport de %ville':      return '%ville airport';   break;
    case 'Gare de %ville':      return '%ville train station';   break;
    case 'personnes':      return 'people';   break;
    case 'personne':      return 'person';   break;
    case 'À quelle heure souhaitez-vous être pris en charge ?':      return 'At what time would you like to be picked up?';   break;
    case 'À quelle heure arrive votre vol ?':      return 'Arrival time of your flight';   break;
    case 'À quelle heure arrive votre train ?':      return 'Arrival time of your train';   break;
    case 'À quelle heure part votre vol ?':      return 'Departure time of your flight';   break;
    case 'À quelle heure part votre train ?':      return 'Departure time of your train';   break;
    case 'Nom':      return 'Last name';   break;
    case 'Prénom':      return 'First name';   break;
    case 'Email':      return 'E-mail';   break;
    case 'Téléphone':      return 'Phone number';   break;
    case 'Entrez vos coordonnées pour complèter votre demande de réservation':      return 'Enter your details to complete your booking request';   break;
    case 'Voulez-vous ajouter un message ?':      return 'Do you want to add a message?';   break;
    case 'Enfants, prise en charge spécifique, etc.':      return 'Children, specific care, etc.';   break;
    case 'Envoyer la demande de réservation':      return 'Send booking request';   break;
    case 'Prise en charge :':      return 'Pick-up:';   break;
    case 'Dépose :':      return 'Drop-off:';   break;
    case 'Date :':      return 'Date:';   break;
    case 'Estimation :':      return 'Estimate:';   break;
    case 'Sous réserve de modification':      return 'Subject to change';   break;
    case 'de réduction':      return 'reduction';   break;
    case 'du prix total aller et retour remis sur le retour':      return 'reduction on total price';   break;
    case 'Votre trajet Vallée vers Station':      return 'Your trip valley to resort';   break;
    case 'Votre trajet Station vers Vallée':      return 'Your trip resort to valley';   break;
    case 'Votre trajet':      return 'Your journey';   break;
    case 'Votre trajet retour':      return 'Your way back';   break;
    case 'Votre trajet aller':      return 'Your outward journey';   break;
    case 'Entrez vos informations pour obtenir une estimation et envoyer une demande de réservation':      return 'Enter your informations to get an estimation and send a booking request';   break;
    case '%count personne':      return '%count person';   break;
    case '%count personnes':      return '%count people';   break;
    case 'Heure de prise en charge :':      return 'Pick-up time:';   break;
    case "Heure d'arrivée :":      return 'Arrival time';   break;
    case "Heure d'arrivée du vol :":      return 'Arrival time of the flight:';   break;
    case "Heure d'arrivée du train :":      return 'Arrival time of the train:';   break;
    case 'Envoyer':      return 'Send';   break;
    case "Demande de réservation en cours d'envoi...":      return 'Booking request being sent...';   break;
    case 'Demande de réservation envoyée':      return 'Booking request sent';   break;
    case 'Nous vous contacterons au plus vite pour confirmer cette réservation.':      return 'We will contact you as soon as possible to confirm this booking.<br><em>Check your spam if you still don\'t get a message in a few days.</em>';   break;
    case 'Ajouter le trajet retour ?':      return 'Add a way back?';   break;
    case 'Chargement du formulaire...':      return 'Loading form ...';   break;
    case 'requis':      return 'required';   break;
    case 'Retour':      return 'Back';   break;
    case "Bénéficiez de 5% de réduction sur votre trajet aller/retour, offre valable pour toute réservation hors haute saison d'hiver (vacances de Noël et de mi-Février à mi-Mars). Remise appliquée sur le trajet retour.":      return 'Get 5% off on your round trip, offer available for all bookings outside the high winter season (Christmas holidays and from mid-February to mid-March). Discount applied on the return journey.';   break;
    case "En soumettant ce formulaire, j'autorise ce site à conserver les données personnelles transmises. Ces données seront utilisées uniquement dans le cadre du traitement de cette demande de réservation. Aucune exploitation commerciale ne sera faite de ces données. Voir notre politique de confidentialité.":      return 'I allow this site to store personal datas submitted via this form. No ads will be sent.';   break;
    case "Heure de départ du vol :":      return 'Flight departure time';   break;
    case "Heure de départ du train :":      return 'Train departure time';   break;
    case "Prestation":      return 'Service';   break;
    case "Non disponible":      return 'Not available';   break;
    case "(7 passagers max)":      return '(7 passengers max)';   break;
    case "Pas de choix de véhicule":      return 'No choice of vehicle';   break;
    case "Mercedes Classe-V Avantgarde XL":      return 'Mercedes V-Class Avantgarde XL';   break;
    case "Sélectionner la prestation souhaitée":      return 'Select the desired service';   break;
    case '<a href="/fr/vehicule" target="_blank">Découvrir les véhicules</a>':      return '<a href="/en/vehicule" target="_blank">Discover the cars</a>';   break;
    case 'Vérifiez vos critères avant de continuer.' : return 'Check your criteria before proceeding.'; break;
    case 'Vous pouvez les modifier en cliquant sur la croix située à côté.' : return 'You can modify them by clicking on the cross next to them.'; break;
    case 'Demandez votre devis' : return 'Ask for your quote'; break;
    case 'Tout autoroute' : return 'All motorway'; break;
    case 'TRAJET TOUT AUTOROUTE' : return 'ALL MOTORWAY ROUTE'; break;
    case "Trajet normal par le Lac d'Annecy" : return 'Standard route via Lake Annecy'; break;
    case "Trajet confort tout autoroute par Chambéry" : return 'Comfortable all-motorway route via Chambéry'; break;

    default: return value;
  }
}